<div class="withdrawal-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Retirar</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Retirar Créditos de Carbono</h1>
  </div>

  <form class="withdrawal-form" [formGroup]="formWithdrawal">
    <div class="form-layout">
      <div class="form-shell">
          <div class="section-block">
            <div class="section-header">
              <div class="section-header__title-group">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Dados do beneficiário</h2>
              </div>
              <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
            </div>
            <div class="fields-row fields-row--1">
              <div class="field-group field-group--labeled">
                <b3-input-text
                  formControlName="purchaserCode"
                  inputId="purchaserCode"
                  label="Registrador"
                  background="white"
                  mask="account"
                  [error]="checkHasError('purchaserCode')"
                  [hint]="[
                    { show: checkHasError('purchaserCode', 'required'), text: 'Campo obrigatório' },
                    { show: checkHasError('purchaserCode'), text: 'Preenchimento inválido' }
                  ] | fieldHint">
                </b3-input-text>
              </div>
            </div>
            <div class="fields-row fields-row--2">
              <div class="field-group field-group--labeled">
                <b3-input-text
                  formControlName="holderCode"
                  inputId="holderCode"
                  label="Detentor"
                  background="white"
                  mask="account"
                  [error]="checkHasError('holderCode')"
                  [hint]="[
                    { show: checkHasError('holderCode', 'required'), text: 'Campo obrigatório' },
                    { show: checkHasError('holderCode'), text: 'Preenchimento inválido' }
                  ] | fieldHint">
                </b3-input-text>
              </div>
              <div class="field-group field-group--labeled tooltip-container" *ngIf="showcpfCnpjComitente">
                <b3-input-text
                  formControlName="cpfCnpjComitente"
                  inputId="cpfCnpjComitente"
                  label="CPF/CNPJ do Comitente"
                  background="white"
                  [mask]="comitenteDocumentMask"
                  placeholder="00.000.000/0000-00"
                  [maxlength]="18"
                  [error]="checkHasError('cpfCnpjComitente') && !comitenteFound"
                  [hint]="[
                    { show: comitenteFound, text: 'Comitente encontrado para conta' },
                    { show: checkHasError('cpfCnpjComitente', 'required'), text: 'Campo obrigatório' },
                    { show: checkHasError('cpfCnpjComitente', 'comitenteInvalido'), text: 'Comitente não encontrado para esta conta' },
                    { show: checkHasError('cpfCnpjComitente'), text: 'CPF/CNPJ inválido' }
                  ] | fieldHint"
                  (b3-blur)="onChangesComitenteCpfOrCnpj()">
                </b3-input-text>
                <span class="tooltip-text">Preencha o CPF/CNPJ do comitente da conta 10</span>
              </div>
            </div>
          </div>

          <div class="section-block">
            <div class="section-header">
              <div class="section-header__title-group">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Dados do ativo</h2>
              </div>
              <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
            </div>
            <div class="fields-row fields-row--2">
              <div class="field-group field-group--labeled">
                <b3-input-text
                  formControlName="carbonCreditCode"
                  inputId="carbonCreditCode"
                  label="Código do instrumento"
                  background="white"
                  mask="instrument"
                  placeholder=""
                  [error]="checkHasError('carbonCreditCode')"
                  [hint]="[
                    { show: checkHasError('carbonCreditCode', 'required'), text: 'Campo obrigatório' }
                  ] | fieldHint">
                </b3-input-text>
              </div>
              <div class="field-group field-group--labeled field-group--quantity">
                <b3-input-text
                  formControlName="creditQuantity"
                  inputId="creditQuantity"
                  label="Quantidade"
                  background="white"
                  mask="integer"
                  placeholder="Apenas números inteiros"
                  [error]="checkHasError('creditQuantity')"
                  [hint]="[
                    { show: checkHasError('creditQuantity', 'required'), text: 'Campo obrigatório' },
                    { show: checkHasError('creditQuantity'), text: 'Preenchimento inválido' }
                  ] | fieldHint"
                  (b3-change)="onChangedccreditQuantity($event)">
                </b3-input-text>
              </div>
            </div>
            <div class="if-quantity-row" *ngIf="showInstrumentQuantity">
              <div class="if-quantity-info">
                <span class="if-quantity-info__label">Quantidade total do IF</span>
                <b3-tag
                  class="if-quantity-badge"
                  size="sm"
                  variant="filled"
                  tone="warning"
                  [label]="'+ ' + instrumentAvailableQuantity + '/' + instrumentTotalQuantity"
                  aria-live="polite">
                </b3-tag>
              </div>
            </div>
          </div>

          <div class="section-block">
            <div class="section-header">
              <div class="section-header__title-group">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Motivo da retirada</h2>
              </div>
              <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
            </div>
            <div class="fields-row fields-row--1">
              <div class="field-group field-group--radios">
                <b3-ds-radio-group
                  formControlName="withdrawalMode"
                  name="withdrawalModeGroup"
                  [options]="withdrawalModeOptions"
                  [error]="checkHasError('withdrawalMode', 'required')"
                  (valueChange)="onWithdrawalModeChange($event)">
                </b3-ds-radio-group>
                <app-field-message [show]="checkHasError('withdrawalMode', 'required')" status="error">Campo obrigatório</app-field-message>
              </div>
            </div>
            <app-psa-add-beneficiary
              #beneficiaryForm
              [formRegister]="formRegister"
              [clearFormNow]="clearFormNow"
              [creditQuantity]="creditQuantity"
              (isApprovedQuantity)="onChangedApprovedQuantity($event)"
              (accumulatedAmount)="onChangedAccumulatedAmount($event)"
              (foreignEntityModalRequest)="onForeignEntityModalRequest($event, beneficiaryForm)"
              (attentionModalRequest)="onAttentionModalRequest()"
              [disabled]="disabledWithdrawalMode">
            </app-psa-add-beneficiary>
          </div>
      </div>

      <div class="aceite-card" *ngIf="!disabledWithdrawalMode">
        <div class="section-header">
          <div class="section-header__title-group">
            <span class="section-header__accent" aria-hidden="true"></span>
            <h2 class="section-header__title">Aceite</h2>
          </div>
          <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
        </div>
        <p class="aceite-text">
          Declaro estar ciente de que esta operação de aposentadoria dos créditos de carbono é irreversível e não
          poderá ser desfeita após a confirmação.
        </p>
        <b3-checkbox
          class="aceite-card__confirm"
          label="Confirmar"
          [selected]="confirmation"
          (b3-change)="confirmationChange($event)">
        </b3-checkbox>
      </div>

      <div class="form-actions" *ngIf="showFormActions" role="group" aria-label="Ações do formulário">
        <b3-button
          type="button"
          variant="ghost"
          tone="default"
          class="form-actions__btn-cancel"
          (b3-click)="onCancel()">
          Cancelar
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          class="form-actions__btn-submit"
          [disabled]="formWithdrawal.invalid || (!disabledWithdrawalMode && ((isRetireMode && beneficiariesArray.length <= 0) || !confirmation || !isQuantityApproved)) || (withdrawalAmountTotal > creditQuantity)"
          (b3-click)="transferenceRegister()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Retirar
        </b3-button>
      </div>
    </div>
  </form>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-modal-success-retirement
  *ngIf="withdrawalResultModal"
  [open]="showWithdrawalResultModal"
  [viewModel]="withdrawalResultModal"
  (action)="onWithdrawalResultModalAction($event)">
</app-modal-success-retirement>

<app-modal-id-retirement
  *ngIf="showForeignEntityModal"
  [open]="showForeignEntityModal"
  [isForeigner]="foreignEntityIsForeigner"
  (closed)="onForeignEntityModalClosed($event)">
</app-modal-id-retirement>

<app-modal-attention-retirement
  *ngIf="showAttentionModal"
  [open]="showAttentionModal"
  (closed)="onAttentionModalClosed()">
</app-modal-attention-retirement>
